<template>
  <v-menu
    ref="dtpMenu"
    v-model="dtpMenu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        readonly
        v-on="on"
        v-bind="attrs"
        :value="formatTime(value)"
        v-on:input="$emit('input', $event)"
        prepend-icon="mdi-clock-time-four-outline"
      >
        <!-- <template v-slot:label>{{ $t(label) }} </template> -->
        <template v-slot:label>{{ label }}</template>
      </v-text-field>
    </template>
    <v-time-picker
      v-if="dtpMenu"
      v-model="selTime"
      full-width
      format="24hr"
      :min="min"
      @click="$refs.dtpMenu.save(selTime)"
    ></v-time-picker>
  </v-menu>
</template>

<script>
export default {
  name: 'time-input',
  props: {
    label: String,
    min: String,
    value: String
  },
  data() {
    return {
      dtpMenu: null,
      time: null
    }
  },
  computed: {
    selTime: {
      get() {
        return this.value;
      },

      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    formatTime(time) {
      if (!time) return null
      const [hour, min] = time.split(':')
      return `${hour}:${min}`
    }
  }
}
</script>